<script>
  // TODO: check and refactore
  // based on https://github.com/theKashey/vue-focus-lock/
  import moveFocusInside, { focusInside, focusIsHidden } from 'focus-lock';

  function deferAction(action) {
    const setImmediate = window.setImmediate;
    if (typeof setImmediate !== 'undefined') {
      setImmediate(action);
    } else {
      setTimeout(action, 1);
    }
  }

  let lastActiveTrap = null;
  let lastActiveFocus = null;
  let instances = [];

  const focusOnBody = () => (
    document && document.activeElement === document.body
  );

  const isFreeFocus = () => focusOnBody() || focusIsHidden();

  const activateTrap = () => {
    if (lastActiveTrap) {
      const { observed } = lastActiveTrap;
      if (!isFreeFocus() || !lastActiveFocus) {
        if (observed && !focusInside(observed)) {
          moveFocusInside(observed, lastActiveFocus);
        }
        lastActiveFocus = document.activeElement;
      }
    }
  };

  const setActiveTrap = () => {
    const trap = instances.filter(({ disabled }) => !disabled).slice(-1)[0];

    if (lastActiveTrap && lastActiveTrap !== trap) {
      lastActiveTrap.vue.$emit('deactivate');
    }

    if (trap && lastActiveTrap !== trap) {
      lastActiveTrap = trap;
      trap.vue.$emit('activate');
    }

    if (trap) {
      deferAction(activateTrap);
    }
  };

  const onTrap = (e) => {
    // prevent scroll jump
    e.stopPropagation();
    e.preventDefault();
  };

  const onBlur = () => {
    deferAction(activateTrap);
  };

  const attachHandler = () => {
    document.addEventListener('focusin', onTrap, true);
    document.addEventListener('focusout', onBlur);
  };

  const detachHandler = () => {
    document.removeEventListener('focusin', onTrap, true);
    document.removeEventListener('focusout', onBlur);
  };

  export default {
    props: {
      returnFocus: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        data: {},
      };
    },
    watch: {
      disabled() {
        this.data.disabled = this.disabled;
        setActiveTrap();
      },
    },
    beforeMount() {
      this.originalFocusedElement = document.activeElement;
    },
    mounted() {
      this.data.vue = this;
      this.data.observed = this.$refs.lock;
      this.data.disabled = this.disabled;

      if (!instances.length) {
        attachHandler();
      }
      instances.push(this.data);
      setActiveTrap();
    },
    destroyed() {
      instances = instances.filter(({ vue }) => vue !== this);
      if (!instances.length) {
        detachHandler();
      }
      if (
        this.returnFocus
        && this.originalFocusedElement
        && this.originalFocusedElement.focus
      ) {
        this.originalFocusedElement.focus();
      }
      setActiveTrap();
    },
  };
</script>

<template>
  <div>
    <div
      :tabIndex="disabled ? -1 : 0"
    />
    <div
      :tabIndex="disabled ? -1 : 1"
    />
    <div ref="lock">
      <slot />
    </div>
    <div
      :tabIndex="disabled ? -1 : 0"
    />
  </div>
</template>
